var Bash = "Bash";
var C = "C";
var Go = "Go";
var Java = "Java";
var JavaScript = "JavaScript";
var Kotlin = "Kotlin";
var Perl = "Perl";
var PHP = "PHP";
var PowerShell = "PowerShell";
var Python = "Python";
var Ruby = "Ruby";
var Rust = "Rust";
var SQL = "SQL";
var Swift = "Swift";
var TypeScript = "TypeScript";
var Analytics = "การวิเคราะห์";
var Blockchain = "บล็อกเชน";
var Compliance = "การปฏิบัติตามข้อกำหนด";
var Compute = "การประมวลผล";
var Containers = "คอนเทนเนอร์";
var Databases = "ฐานข้อมูล";
var Games = "เกม";
var Migration = "การโยกย้าย";
var Mobile = "มือถือ";
var Networking = "การสร้างเครือข่าย";
var Robotics = "วิทยาการหุ่นยนต์";
var Satellite = "ดาวเทียม";
var Security = "การรักษาความปลอดภัย";
var Serverless = "ไร้เซิร์ฟเวอร์";
var Storage = "พื้นที่จัดเก็บ";
var WebApps = "WebApps";
var Alexa = "Alexa";
var Apache = "Apache";
var App2Container = "App2Container";
var AppFabric = "AppFabric";
var AppFlow = "AppFlow";
var AppSync = "AppSync";
var Artifact = "อาร์ทิแฟกต์";
var Athena = "Athena";
var Aurora = "Aurora";
var Backup = "การสำรองข้อมูล";
var Batch = "แบตช์";
var Bedrock = "Bedrock";
var Braket = "Braket";
var Budgets = "Budgets";
var Chatbot = "Chatbot";
var Chime = "Chime";
var Cloud9 = "Cloud9";
var CloudEndure = "CloudEndure";
var CloudFormation = "CloudFormation";
var CloudFront = "CloudFront";
var CloudHSM = "CloudHSM";
var CloudSearch = "CloudSearch";
var CloudShell = "CloudShell";
var CloudTrail = "CloudTrail";
var CloudWatch = "CloudWatch";
var CodeArtifact = "CodeArtifact";
var CodeBuild = "CodeBuild";
var CodeCatalyst = "CodeCatalyst";
var CodeCommit = "CodeCommit";
var CodeDeploy = "CodeDeploy";
var CodeGuru = "CodeGuru";
var CodePipeline = "CodePipeline";
var CodeStar = "CodeStar";
var Cognito = "Cognito";
var Comprehend = "Comprehend";
var Config = "Config";
var Connect = "Connect";
var Copilot = "Copilot";
var Corretto = "Corretto";
var Dash = "Dash";
var DataSync = "DataSync";
var DataZone = "DataZone";
var DeepComposer = "DeepComposer";
var DeepLens = "DeepLens";
var DeepRacer = "DeepRacer";
var Detective = "เชิงสืบหา";
var DocumentDB = "DocumentDB";
var DynamoDB = "DynamoDB";
var EMR = "EMR";
var EventBridge = "EventBridge";
var Fargate = "Fargate";
var FinSpace = "FinSpace";
var Forecast = "Forecast";
var FreeRTOS = "FreeRTOS";
var FSx = "FSx";
var GameKit = "GameKit";
var GameLift = "GameLift";
var GameSparks = "GameSparks";
var Glue = "Glue";
var GuardDuty = "GuardDuty";
var Health = "สุขภาพ";
var HealthLake = "HealthLake";
var Inferentia = "Inferentia";
var Inspector = "Inspector";
var Kendra = "Kendra";
var Kinesis = "Kinesis";
var Lambda = "Lambda";
var Lex = "Lex";
var Lightsail = "Lightsail";
var Lookout = "Lookout";
var Lumberyard = "Lumberyard";
var Macie = "Macie";
var Monitron = "Monitron";
var Neptune = "Neptune";
var Neuron = "Neuron";
var One = "หนึ่งคน";
var OpenShift = "OpenShift";
var OpsWorks = "OpsWorks";
var Organizations = "Organizations";
var Outposts = "Outposts";
var Panorama = "Panorama";
var Personalize = "ปรับแต่ง";
var Pinpoint = "Pinpoint";
var Polly = "Polly";
var PrivateLink = "PrivateLink";
var Prometheus = "Prometheus";
var Proton = "Proton";
var QuickSight = "QuickSight";
var Redshift = "Redshift";
var Rekognition = "Rekognition";
var RoboMaker = "RoboMaker";
var SageMaker = "SageMaker";
var Shield = "Shield";
var Snowball = "Snowball";
var Snowcone = "Snowcone";
var Snowmobile = "Snowmobile";
var Sumerian = "Sumerian";
var TensorFlow = "TensorFlow";
var Textract = "Textract";
var Thinkbox = "Thinkbox";
var Timestream = "Timestream";
var Titan = "Titan";
var Transcribe = "Transcribe";
var Translate = "Translate";
var VMware = "VMware";
var Wavelength = "Wavelength";
var Wickr = "Wickr";
var WorkDocs = "WorkDocs";
var WorkLink = "WorkLink";
var WorkMail = "WorkMail";
var WorkSpaces = "WorkSpaces";
var interests = {
	".NET": ".NET",
	Bash: Bash,
	C: C,
	"C#": "C#",
	"C++": "C++",
	Go: Go,
	Java: Java,
	JavaScript: JavaScript,
	Kotlin: Kotlin,
	Perl: Perl,
	PHP: PHP,
	PowerShell: PowerShell,
	Python: Python,
	Ruby: Ruby,
	Rust: Rust,
	"SAP ABAP": "SAP ABAP",
	SQL: SQL,
	Swift: Swift,
	TypeScript: TypeScript,
	Analytics: Analytics,
	"Application Integration": "การผสานรวมแอปพลิเคชัน",
	"AR/VR": "AR/VR",
	"Architecture Strategy": "กลยุทธ์ทางสถาปัตยกรรม",
	"Artificial Intelligence": "ปัญญาประดิษฐ์",
	Blockchain: Blockchain,
	"Business applications": "การใช้งานทางธุรกิจ",
	"Cloud Financial Management": "การจัดการการเงินบนระบบคลาวด์",
	"Cloud Foundations": "พื้นฐานระบบคลาวด์",
	Compliance: Compliance,
	Compute: Compute,
	"Contact Center": "ศูนย์การติดต่อ",
	Containers: Containers,
	"Data Integration": "การผสานรวมข้อมูล",
	Databases: Databases,
	"Developer Tools": "เครื่องมือนักพัฒนา",
	"End-User Computing (EUC)": "การประมวลผลสำหรับผู้ใช้ปลายทาง (EUC)",
	"Front-End Development": "การพัฒนาฟรอนต์เอนด์",
	Games: Games,
	"Generative AI": "AI ช่วยสร้าง",
	"High Performance Computing (HPC)": "การประมวลผลประสิทธิภาพสูง (HPC)",
	"Identity Management": "การจัดการข้อมูลประจำตัว",
	"Machine Learning": "แมชชีนเลิร์นนิง",
	"Machine Learning & AI": "แมชชีนเลิร์นนิงและ AI",
	"Management & Governance": "การจัดการและการกำกับดูแล",
	"Media services": "บริการสื่อ",
	Migration: Migration,
	Mobile: Mobile,
	Networking: Networking,
	"Networking & Content Delivery": "เครือข่ายและการส่งมอบเนื้อหา",
	"Quantum Technologies": "เทคโนโลยีควอนตัม",
	Robotics: Robotics,
	Satellite: Satellite,
	Security: Security,
	"Security, Identity, & Compliance": "การรักษาความปลอดภัย ตัวตน และการปฏิบัติตามข้อกำหนด",
	Serverless: Serverless,
	Storage: Storage,
	WebApps: WebApps,
	"API Gateway": "API Gateway",
	Alexa: Alexa,
	Apache: Apache,
	"Apache Airflow": "Apache Airflow",
	"Apache Kafka": "Apache Kafka",
	"APP Config": "APP Config",
	"App Mesh": "App Mesh",
	"App Runner": "App Runner",
	"App Studio": "App Studio",
	App2Container: App2Container,
	AppFabric: AppFabric,
	AppFlow: AppFlow,
	"Application Discovery Service": "Application Discovery Service",
	"Application Migration Service": "Application Migration Service",
	"AppStream 2.0": "AppStream 2.0",
	AppSync: AppSync,
	Artifact: Artifact,
	Athena: Athena,
	"Audit Manager": "Audit Manager",
	Aurora: Aurora,
	"Auto Scaling": "Auto Scaling",
	Backup: Backup,
	Batch: Batch,
	Bedrock: Bedrock,
	"Billing Conductor": "Billing Conductor",
	Braket: Braket,
	Budgets: Budgets,
	"Certificate Manager": "Certificate Manager",
	Chatbot: Chatbot,
	Chime: Chime,
	"Clean Rooms": "Clean Rooms",
	"Cloud Control API": "API การควบคุมระบบคลาวด์",
	"Cloud Development Kit (CDK)": "Cloud Development Kit (CDK)",
	"Cloud Directory": "Cloud Directory",
	"Cloud Map": "Cloud Map",
	"Cloud WAN": "Cloud WAN",
	Cloud9: Cloud9,
	CloudEndure: CloudEndure,
	CloudFormation: CloudFormation,
	CloudFront: CloudFront,
	CloudHSM: CloudHSM,
	CloudSearch: CloudSearch,
	CloudShell: CloudShell,
	CloudTrail: CloudTrail,
	CloudWatch: CloudWatch,
	CodeArtifact: CodeArtifact,
	CodeBuild: CodeBuild,
	CodeCatalyst: CodeCatalyst,
	CodeCommit: CodeCommit,
	CodeDeploy: CodeDeploy,
	CodeGuru: CodeGuru,
	CodePipeline: CodePipeline,
	CodeStar: CodeStar,
	Cognito: Cognito,
	Comprehend: Comprehend,
	"Compute Optimizer": "Compute Optimizer",
	Config: Config,
	Connect: Connect,
	"Control Tower": "Control Tower",
	Copilot: Copilot,
	Corretto: Corretto,
	"Cost Explorer": "Cost Explorer",
	Dash: Dash,
	"Data Exchange": "Data Exchange",
	"Data Pipeline": "Data Pipeline",
	"Database Migration Service (DMS)": "Database Migration Service (DMS)",
	DataSync: DataSync,
	DataZone: DataZone,
	"Deadline Cloud": "Deadline Cloud",
	"Deep Learning": "ดีปเลิร์นนิง",
	DeepComposer: DeepComposer,
	DeepLens: DeepLens,
	DeepRacer: DeepRacer,
	Detective: Detective,
	"Device Farm": "Device Farm",
	"DevOps Guru": "DevOps Guru",
	" Direct Connect": " Direct Connect",
	"Directory Service": "Directory Service",
	"Distro for OpenTelemetry": "Distro สำหรับ OpenTelemetry",
	DocumentDB: DocumentDB,
	DynamoDB: DynamoDB,
	"Elastic Beanstalk": "Elastic Beanstalk",
	"Elastic Block Storage (EBS)": "Elastic Block Storage (EBS)",
	"Elastic Cloud Compute (EC2)": "Elastic Cloud Compute (EC2)",
	"Elastic Container Registry (ECR)": "Elastic Container Registry (ECR)",
	"Elastic Container Service (ECS)": "Elastic Container Service (ECS)",
	"Elastic Disaster Recovery (DRS)": "Elastic Disaster Recovery (DRS)",
	"Elastic File System (EFS)": "Elastic File System (EFS)",
	"Elastic Inference": "Elastic Inference",
	"Elastic Kubernetes Service (EKS)": "Elastic Kubernetes Service (EKS)",
	"Elastic Transcoder": "Elastic Transcoder",
	"Elemental ": "Elemental ",
	EMR: EMR,
	EventBridge: EventBridge,
	Fargate: Fargate,
	"Fault Injection Simulator": "เครื่องมือจำลองการฉีดข้อผิดพลาดเพื่อทดสอบ",
	"File Cache": "File Cache",
	FinSpace: FinSpace,
	"Firewall Manager": "Firewall Manager",
	Forecast: Forecast,
	"Fraud Detector": "Fraud Detector",
	FreeRTOS: FreeRTOS,
	FSx: FSx,
	GameKit: GameKit,
	GameLift: GameLift,
	GameSparks: GameSparks,
	"Global Accelerator": "Global Accelerator",
	Glue: Glue,
	"Ground Station": "Ground Station",
	GuardDuty: GuardDuty,
	Health: Health,
	HealthLake: HealthLake,
	"IAM Identity Center": "ศูนย์ข้อมูลประจำตัวของ IAM",
	"Identity and Access Management (IAM)": "การจัดการข้อมูลประจำตัวและการเข้าถึง (IAM)",
	Inferentia: Inferentia,
	Inspector: Inspector,
	"Interactive Video Service": "Interactive Video Service",
	"Internet of Things (IoT)": "อินเทอร์เน็ตในทุกสิ่ง (IoT)",
	Kendra: Kendra,
	"Key Management Service (KMS)": "Key Management Service (KMS)",
	Kinesis: Kinesis,
	"Lake Formation": "Lake Formation",
	Lambda: Lambda,
	"Launch Wizard": "Launch Wizard",
	Lex: Lex,
	"License Manager": "License Manager",
	Lightsail: Lightsail,
	"Local Zones": "Local Zones",
	"Location Service": "Location Service",
	Lookout: Lookout,
	Lumberyard: Lumberyard,
	Macie: Macie,
	"Mainframe Modernization": "Mainframe Modernization",
	"Managed Blockchain": "Managed Blockchain",
	"Managed Grafana": "Managed Grafana",
	Monitron: Monitron,
	"MQ Message Broker": "MQ Message Broker",
	Neptune: Neptune,
	"Network Firewall": "Network Firewall",
	Neuron: Neuron,
	"Nimble Studio": "Nimble Studio",
	One: One,
	"OpenSearch Service (OSS)": "บริการ OpenSearch (OSS)",
	OpenShift: OpenShift,
	OpsWorks: OpsWorks,
	Organizations: Organizations,
	Outposts: Outposts,
	Panorama: Panorama,
	Personalize: Personalize,
	Pinpoint: Pinpoint,
	Polly: Polly,
	"Private 5G": "5G ส่วนตัว",
	"Private Certificate Authority": "Private Certificate Authority",
	PrivateLink: PrivateLink,
	Prometheus: Prometheus,
	Proton: Proton,
	"Q ": "Q ",
	"Quantum Solutions Lab": "Quantum Solutions Lab",
	QuickSight: QuickSight,
	"Relational Database Service (RDS)": "บริการฐานข้อมูลแบบเชิงสัมพันธ์ (RDS)",
	Redshift: Redshift,
	Rekognition: Rekognition,
	"rePost Private": "rePost Private",
	"Resilience Hub": "Resilience Hub",
	"Resource Access Manager": "Resource Access Manager",
	RoboMaker: RoboMaker,
	"Route 53": "Route 53",
	SageMaker: SageMaker,
	"Secrets Manager": "Secrets Manager",
	"Security Hub": "Security Hub",
	"Security Lake": "ที่จัดเก็บข้อมูลการรักษาความปลอดภัย",
	"Server Migration Service (SMS)": "Server Migration Service (SMS)",
	"Serverless Application Repository": "Serverless Application Repository",
	"Service Catalog": "Service Catalog",
	"Service Management Connector": "Service Management Connector",
	Shield: Shield,
	"Simple Email Service (SES)": "Simple Email Service (SES)",
	"Simple Notification Service (SNS)": "Simple Notification Service (SNS)",
	"Simple Queue Service (SQS)": "Simple Queue Service (SQS)",
	"Simple Storage Service (S3)": "Simple Storage Service (S3)",
	"Simspace Weaver": "Simspace Weaver",
	"Single Sign-On (SSO)": "การเข้าสู่ระบบครั้งเดียว (SSO)",
	"Snow Family": "Snow Family",
	Snowball: Snowball,
	Snowcone: Snowcone,
	Snowmobile: Snowmobile,
	"Step Functions": "Step Functions",
	"Storage Gateway": "Storage Gateway",
	Sumerian: Sumerian,
	"Supply Chain": "ห่วงโซ่อุปทาน",
	"Systems Manager": "Systems Manager",
	"Telco Network Builder": "Telco Network Builder",
	TensorFlow: TensorFlow,
	Textract: Textract,
	Thinkbox: Thinkbox,
	Timestream: Timestream,
	Titan: Titan,
	Transcribe: Transcribe,
	Translate: Translate,
	"Trusted Advisor": "Trusted Advisor",
	"Verified Access": "การเข้าถึงที่ได้รับการยืนยัน",
	"Verified Permissions": "สิทธิ์ที่ได้รับการยืนยัน",
	"Virtual Private Cloud (VPC)": "Virtual Private Cloud (VPC)",
	"Virtual Private Network (VPN)": "Virtual Private Network (VPN)",
	VMware: VMware,
	Wavelength: Wavelength,
	"Web Application Firewall (WAF)": "ไฟร์วอลล์สำหรับเว็บแอปพลิเคชัน (WAF)",
	Wickr: Wickr,
	WorkDocs: WorkDocs,
	WorkLink: WorkLink,
	WorkMail: WorkMail,
	WorkSpaces: WorkSpaces,
	"X-Ray": "X-Ray"
};

export { Alexa, Analytics, Apache, App2Container, AppFabric, AppFlow, AppSync, Artifact, Athena, Aurora, Backup, Bash, Batch, Bedrock, Blockchain, Braket, Budgets, C, Chatbot, Chime, Cloud9, CloudEndure, CloudFormation, CloudFront, CloudHSM, CloudSearch, CloudShell, CloudTrail, CloudWatch, CodeArtifact, CodeBuild, CodeCatalyst, CodeCommit, CodeDeploy, CodeGuru, CodePipeline, CodeStar, Cognito, Compliance, Comprehend, Compute, Config, Connect, Containers, Copilot, Corretto, Dash, DataSync, DataZone, Databases, DeepComposer, DeepLens, DeepRacer, Detective, DocumentDB, DynamoDB, EMR, EventBridge, FSx, Fargate, FinSpace, Forecast, FreeRTOS, GameKit, GameLift, GameSparks, Games, Glue, Go, GuardDuty, Health, HealthLake, Inferentia, Inspector, Java, JavaScript, Kendra, Kinesis, Kotlin, Lambda, Lex, Lightsail, Lookout, Lumberyard, Macie, Migration, Mobile, Monitron, Neptune, Networking, Neuron, One, OpenShift, OpsWorks, Organizations, Outposts, PHP, Panorama, Perl, Personalize, Pinpoint, Polly, PowerShell, PrivateLink, Prometheus, Proton, Python, QuickSight, Redshift, Rekognition, RoboMaker, Robotics, Ruby, Rust, SQL, SageMaker, Satellite, Security, Serverless, Shield, Snowball, Snowcone, Snowmobile, Storage, Sumerian, Swift, TensorFlow, Textract, Thinkbox, Timestream, Titan, Transcribe, Translate, TypeScript, VMware, Wavelength, WebApps, Wickr, WorkDocs, WorkLink, WorkMail, WorkSpaces, interests as default };
